import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './HomePage';
import AboutUsPage from './AboutUsPage';
import ProductsPage from './ProductsPage';
import InfrastructurePage from './InfrastructurePage';
import FAQPage from './FAQPage';
import ContactUsPage from './ContactUsPage';
import NotFoundPage from './NotFoundPage';
import ScrollToTop from './ScrollToTop';

import Header from './Header';
import Footer from './Footer';

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Header />

          <main className="flex-grow">
            <Routes>
              <Route exact path="/" element={<HomePage />} />
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/home/" element={<Navigate to="/" replace />} />
              <Route path="/Infrastructure.html" element={<Navigate to="/infrastructure" replace />} />
              <Route path="/About-us.html" element={<Navigate to="/about" replace />} />
              <Route path="/Contact-us.html" element={<Navigate to="/contact" replace />} />
              <Route path="/FAQ.html" element={<Navigate to="/faq" replace />} />
              <Route path="/Products.html" element={<Navigate to="/products" replace />} />
              <Route path="*" element={<NotFoundPage />} />
              <Route path="/about" element={<AboutUsPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/infrastructure" element={<InfrastructurePage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactUsPage />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;